import React, { memo } from 'react'
import { Button, Intent, Tooltip } from '@blueprintjs/core'
import { useTranslation } from 'react-i18next'
const LockButton = ({ showPassword, toggle }) => {
  const { t } = useTranslation()
  return (
    <Tooltip content={t(`${showPassword ? 'hide' : 'show'}_password`)}>
      <Button type='button' icon={showPassword ? 'unlock' : 'lock'} intent={Intent.WARNING} minimal={true} onClick={toggle} />
    </Tooltip>
  )
}
export default memo(LockButton)
